export const filterExists = (filters, name, group) => (
  filters.find((f) => f.name === name && f.group === group) !== undefined
);

export const addFilter = (setFilters, name, group, fnc, field) => {
  setFilters((currentFilters) => [...currentFilters, { name, group, field: field || group, fnc }]);
}

export const removeFilter = (setFilters, name, group) => {
  setFilters((currentFilters) =>
    currentFilters.filter((f) => !(f.name === name && f.group === group))
  );
}

export const toggleFilter = (filters, setFilters, name, group, fnc, field) => {
  if(filterExists(filters, name, group))
    removeFilter(setFilters, name, group)
  else
    addFilter(setFilters, name, group, fnc, field)
}
